export const constants = {
  GET_GRADUACIONES_CONTACT_REQUEST: 'GET_GRADUACIONES_CONTACT_REQUEST',
  GET_GRADUACIONES_CONTACT_SUCCESS: 'GET_GRADUACIONES_CONTACT_SUCCESS',
  GET_GRADUACIONES_CONTACT_FAILURE: 'GET_GRADUACIONES_CONTACT_FAILURE',

  GET_GRADUACION_CONTACTOLOGICA_REQUEST: 'GET_GRADUACION_CONTACTOLOGICA_REQUEST',
  GET_GRADUACION_CONTACTOLOGICA_SUCCESS: 'GET_GRADUACION_CONTACTOLOGICA_SUCCESS',
  GET_GRADUACION_CONTACTOLOGICA_FAILURE: 'GET_GRADUACION_CONTACTOLOGICA_FAILURE',

  GET_GRADUACION_ULTIMA_OPTOMETRIA_REQUEST: 'GET_GRADUACION_ULTIMA_OPTOMETRIA_REQUEST',
  GET_GRADUACION_ULTIMA_OPTOMETRIA_SUCCESS: 'GET_GRADUACION_ULTIMA_OPTOMETRIA_SUCCESS',
  GET_GRADUACION_ULTIMA_OPTOMETRIA_FAILURE: 'GET_GRADUACION_ULTIMA_OPTOMETRIA_FAILURE',

  GUARDAR_GRADUACION_CONTACTOLOGICA_REQUEST: 'GUARDAR_GRADUACION_CONTACTOLOGICA_REQUEST',
  GUARDAR_GRADUACION_CONTACTOLOGICA_SUCCESS: 'GUARDAR_GRADUACION_CONTACTOLOGICA_SUCCESS',
  GUARDAR_GRADUACION_CONTACTOLOGICA_FAILURE: 'GUARDAR_GRADUACION_CONTACTOLOGICA_FAILURE',

};
